import React, { useEffect, useState } from 'react';
import {
    Box,
    Stack,
    TablePagination,
    Tooltip,
    Typography,
} from '@mui/material';
import pxToRem from 'assets/theme/function/px-to-rem';
import Filter from 'component/filter';
import FilterUsers from 'pages/users/users-filter';
import { RowDataType, TableMetaData } from 'types/common/common';
import { UsersListRequest } from 'types/users/users';
import colors from 'assets/theme/base/colors';
import borders from 'assets/theme/base/borders';
import FlexibleTable from 'component/flexible-table';
import { API_ENDPOINT_URL } from 'constant';
import { StyledTableRow } from 'component/tabel-pagination-style';
import { useNavigate } from 'react-router-dom';
import { useLazyUsersListQuery } from 'store/slices/user/user';
import RedeemIcon from '@mui/icons-material/Redeem';

export const initialListData: UsersListRequest = {
    page: 1,
    pageSize: 30,
    sort: 'createdat',
};

const defaultTableStaffDataList: TableMetaData[] = [
    {
        key: 'img',
        position: 1,
        title: 'Avatar Image',
        isSortable: false,
    },
    {
        key: 'nickname',
        position: 2,
        title: 'User Name',
        isSortable: true,
    },
    {
        key: 'email',
        position: 3,
        title: 'User Email ',
        isSortable: false,
    },

    {
        key: 'cardCount',
        position: 4,
        title: 'Card Count',
        isSortable: false,
    },

    {
        key: 'userStatus',
        position: 5,
        title: 'User status ',
        isSortable: false,
    },

    {
        key: 'createdat',
        position: 7,
        title: 'Creation Data',
        isSortable: true,
        type: 'date',
        format: 'DD.MM.YYYY HH:mm',
    },

    {
        key: 'action',
        position: 8,
        title: 'Action',
        isSortable: false,
    },
];
const Users: React.FC = () => {
    const [tableMetaDataList, setTableMetaDataList] = useState<TableMetaData[]>(
        defaultTableStaffDataList,
    );
    const [dataUsersRequestList, setDataUsersRequestList] =
        React.useState<UsersListRequest>(initialListData);
    const [pagesCount, setPagesCount] = useState<number>(0);
    const [page, setPage] = useState<number>(initialListData?.page);
    const [pageSize, setPageSize] = useState<number>(
        initialListData?.pageSize ?? 0,
    );
    const [sort, setSort] = useState<string>('createdat');
    const [tableData, setTableData] = useState<RowDataType[]>([]);

    const [getUsersList, { data }] = useLazyUsersListQuery();

    const navigate = useNavigate();
    const handleClickUser = (userId: string) => {
        navigate(`/users/${userId}`);
    };

    const handelClickPresentUser = () => {
        console.log('mi sxmi');
    };
    const handleFilterData = (currentPage = 0) => {
        setPage(currentPage + 1);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setPageSize(Number(event.target.value));
        setPage(1);
    };

    useEffect(() => {
        setPagesCount(
            data && data?.data.length > 0 ? Number(data?.rowsCount) : 0,
        );
        const tableData: RowDataType[] = data
            ? data.data.map((fullInfo) => {
                  return {
                      ...fullInfo,
                      img: (
                          <>
                              {fullInfo?.id ? (
                                  <Box
                                      component="img"
                                      src={`${API_ENDPOINT_URL}/avatar/file/${fullInfo.selectedAvatarId}`}
                                      alt=""
                                      sx={{
                                          width: 60,
                                          height: 60,
                                          objectFit: 'cover',
                                          objectPosition: 'top',
                                          borderRadius:
                                              borders.borderRadius.section,
                                      }}
                                  />
                              ) : (
                                  <Typography variant="h5">-</Typography>
                              )}
                          </>
                      ),
                      action: (
                          <Box display="flex" justifyContent="center" gap={2}>
                              <Tooltip title="Present">
                                  <RedeemIcon
                                      cursor="pointer"
                                      onClick={(event) => {
                                          event.stopPropagation();
                                          handelClickPresentUser();
                                      }}
                                  />
                              </Tooltip>
                          </Box>
                      ),
                      rowComponent: StyledTableRow,
                      rowProps: {
                          onClick: () => handleClickUser(fullInfo.id || ''),
                      },
                  };
              })
            : [];
        setTableData(tableData);
    }, [data]);

    useEffect(() => {
        if (dataUsersRequestList) {
            getUsersList({
                ...dataUsersRequestList,
                sort: sort === '' ? initialListData.sort : sort,
                page: page,
                pageSize: pageSize,
            });
        }
    }, [dataUsersRequestList, page, pageSize, sort]);

    return (
        <>
            <Filter>
                <FilterUsers
                    setDataUsersRequestList={setDataUsersRequestList}
                />
            </Filter>
            <Box
                bgcolor={colors.secondary.light}
                borderRadius={borders.borderRadius.md}
                mt={pxToRem(7)}
            >
                <FlexibleTable
                    tableMetaDataList={tableMetaDataList}
                    setTableMetaDataList={setTableMetaDataList}
                    tableDataList={tableData}
                    sort={sort}
                    setSort={setSort}
                    rowClickFunction={(row) => handleClickUser(row.id)}
                />
                {pagesCount > 0 && (
                    <Stack spacing={2} alignItems={'end'}>
                        <TablePagination
                            rowsPerPageOptions={[10, 30, 50]}
                            component="div"
                            count={pagesCount}
                            rowsPerPage={pageSize}
                            page={page - 1}
                            labelRowsPerPage={'Number of rows'}
                            slotProps={{
                                select: {
                                    inputProps: {
                                        'aria-label': 'rows per page',
                                    },
                                    MenuProps: {
                                        disablePortal: true,
                                        slotProps: {
                                            paper: {
                                                sx: {
                                                    backgroundColor:
                                                        colors.secondary.main,
                                                    padding: 0,
                                                },
                                            },
                                        },
                                    },
                                    native: false,
                                },
                            }}
                            onPageChange={(_, page) => handleFilterData(page)}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Stack>
                )}
            </Box>
        </>
    );
};

export default Users;
